import { Controller } from "remult";

@Controller("partner-organization-lead-methods")
export class PartnerOrganizationLeadMethods {}
